import React, { FC } from 'react';

interface ISack {
  className: string;
}
const Sack: FC<ISack> = (props) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13751_773)">
      <path
        opacity="0.4"
        d="M6.00006 3H10.0001L11.4813 0.7775C11.5316 0.702204 11.5604 0.614683 11.5648 0.524274C11.5692 0.433865 11.549 0.343958 11.5063 0.264145C11.4636 0.184332 11.4 0.117607 11.3224 0.0710869C11.2447 0.024567 11.1559 -2.23135e-06 11.0654 1.51993e-10L4.93569 1.51993e-10C4.84517 -2.23135e-06 4.75635 0.024567 4.67871 0.0710869C4.60106 0.117607 4.5375 0.184332 4.4948 0.264145C4.4521 0.343958 4.43187 0.433865 4.43627 0.524274C4.44066 0.614683 4.46952 0.702204 4.51975 0.7775L6.00006 3ZM10.0001 4H6.00006C-0.324311 7.60625 0.00287671 12.395 0.00287671 13C0.00287671 14.6562 1.53756 16 3.43038 16H12.5704C14.4635 16 15.9979 14.6562 15.9979 13C15.9979 12.4062 16.2901 7.58625 10.0001 4Z"
        fill="#213F7D"
      />
      <path
        d="M10.5312 3.25V3.75C10.5312 3.8163 10.5049 3.87989 10.458 3.92678C10.4111 3.97366 10.3476 4 10.2812 4H5.71875C5.65245 4 5.58886 3.97366 5.54197 3.92678C5.49509 3.87989 5.46875 3.8163 5.46875 3.75V3.25C5.46875 3.1837 5.49509 3.12011 5.54197 3.07322C5.58886 3.02634 5.65245 3 5.71875 3H10.2812C10.3476 3 10.4111 3.02634 10.458 3.07322C10.5049 3.12011 10.5312 3.1837 10.5312 3.25Z"
        fill="#213F7D"
      />
      <path
        d="M5.87516 12.2037V9.94087H5V9.25493H5.87516V7H7.11301L8.34297 9.25493H9.17871V7H10.1248V9.25493H11V9.94087H10.1248V12.2037H8.88699L7.64126 9.94087H6.82129V12.2037H5.87516ZM6.82129 9.18397V9.25493H7.26281L6.80552 8.33246H6.79763L6.82129 9.18397ZM9.19448 10.8949H9.21025L9.17871 10.0749V9.94087H8.71354L8.74507 9.98817L9.19448 10.8949Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_13751_773">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Sack;
